import React from "react";
import "./index.scss";
import { Box, Button, Illustration, Text, UnorderedList } from "@mbank-design/design-system/components";
import { IllustrationSize } from "@mbank-design/design-system/enums";
import * as Illustrations from "@mbank-design/design-system/illustrations";
import SpecialPromotions from "../SpecialPromotions";
import "./index.scss";
const PromoBannerForAll = ({ literals, urlToContactSection, handleContactModal }) => {
  if (
    !literals.promo_label_new_car_title ||
    !literals.promo_label_new_car_subtitle ||
    !literals.promo_label_new_car_illustration ||
    !literals.promo_label_afterlease_car_title ||
    !literals.promo_label_afterlease_car_subtitle ||
    !literals.promo_label_afterlease_car_illustration
  ) {
    return;
  }
  const handleButtonClick = () => {
    setLocalStorageContactPreference();
    handleContactModal(urlToContactSection);
  };

  const setLocalStorageContactPreference = () => {
    localStorage.setItem("onlyOffer", true);
    // LinkedIn Insight Tag
    // setVehicleOfferButtonInsightTag();
  };

  const convertColorLiteral = (literal) => {
    literal = literal.replaceAll("[SPAN]", "<span>");
    literal = literal.replaceAll("[/SPAN]", "</span>");

    literal = literal.replaceAll("[SPAN", "<span");
    literal = literal.replaceAll('"]', '">');
    return literal;
  };
  return (
    <div className="promo-banner-for-all">
      <div className="promo-banner-for-all__content">
        <div className="promo-banner-for-all__left">
          <div className="promo-banner-for-all__title">
          <Box background={"#ff8600"} padding={8} borderRadius={"small"} width={"fit-content"}>
            <Text as={"p"} color={"white30"}>
              łączymy promocje
            </Text>
          </Box>
            {(
              <Text
                as={"h1"}
                marginTop={6}
                marginBottom={6}
                fontSize={36}
              >
                <span style={{ color: "#ff8600" }}>4500 zł</span> dla klientów mBanku
              </Text>
            )}
          </div>
          <div className="promo-banner-for-all__subtitle">
            <UnorderedList spacing={4}>
              <UnorderedList.Item>
                <Text as={"p"}>
                  <strong>2000 zł</strong> – na nowe lub poleasingowe auto z mAuto.pl
                </Text>
              </UnorderedList.Item>
              <UnorderedList.Item>
                <Text as={"p"}>
                  <strong>2000 zł</strong> – za pakiet ubezpieczeń OC + AC + GAP
                </Text>
              </UnorderedList.Item>
              <UnorderedList.Item>
                <Text as={"p"}>
                  <strong>500 zł</strong> – za założenie konta firmowego w mBanku
                </Text>
              </UnorderedList.Item>
            </UnorderedList>
          </div>
          <div className="promo-banner-for-all__button">
            <Button buttonType="primary" onClick={handleButtonClick}>
              zapytaj o ofertę
            </Button>
          </div>
          </div>
        <div className="promo-banner-for-all__right">
          <Illustration
            size={IllustrationSize.MEDIUM}
            illustrationComponent={Illustrations.CarHighwayMass}
          />
        </div>
      </div>
      <div>
        <Text as={"body"} marginTop={12} fontSize={12}>
          regulaminy: <a href="https://mleasing.pl/pdf/promocje/Regulamin-Paliwo-w-prezencie-dla-klientow-mBanku.pdf" target="_blank" rel="noreferrer">Karta paliwowa w prezencie</a>,&nbsp;<a href="https://mleasing.pl/pdf/promocje/Taniej-z-mAuto-edycja-4.pdf" target="_blank" rel="noreferrer">Taniej z mAuto</a>,&nbsp;<a href="https://mleasing.pl/pdf/promocje/wiecej-za-mniej.pdf" target="_blank" rel="noreferrer">Więcej za mniej</a>,&nbsp;<a href="https://mleasing.pl/pdf/promocje/Regulamin-promocji-Ekstra-premia.pdf" target="_blank" rel="noreferrer">Ekstra premia</a>
        </Text>
      </div>
    </div>
  );
};

export default PromoBannerForAll;
